/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const IdDiamondCar1 = ({ className }) => {
  return (
    <svg
      className={`id-diamond-car-1 ${className}`}
      fill="none"
      height="45"
      viewBox="0 0 45 45"
      width="45"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="rect"
        fill="#F2F3F7"
        height="36.7695"
        rx="18.3848"
        transform="rotate(45 22.5 -3.31348)"
        width="36.7695"
        x="22.5"
        y="-3.31348"
      />

      <g className="g" clipPath="url(#clip0_2633_291)">
        <path
          className="path"
          d="M19.667 34.0688C20.2193 34.0688 20.667 33.6211 20.667 33.0688C20.667 32.5166 20.2193 32.0688 19.667 32.0688C19.1147 32.0688 18.667 32.5166 18.667 33.0688C18.667 33.6211 19.1147 34.0688 19.667 34.0688Z"
          stroke="#2222E3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />

        <path
          className="path"
          d="M30.667 34.0688C31.2193 34.0688 31.667 33.6211 31.667 33.0688C31.667 32.5166 31.2193 32.0688 30.667 32.0688C30.1147 32.0688 29.667 32.5166 29.667 33.0688C29.667 33.6211 30.1147 34.0688 30.667 34.0688Z"
          stroke="#2222E3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />

        <path
          className="path"
          d="M11.667 13.0688H15.667L18.347 26.4588C18.4384 26.9192 18.6889 27.3328 19.0545 27.6271C19.4202 27.9215 19.8777 28.0778 20.347 28.0688H30.067C30.5363 28.0778 30.9938 27.9215 31.3594 27.6271C31.7251 27.3328 31.9755 26.9192 32.067 26.4588L33.667 18.0688H16.667"
          stroke="#2222E3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>

      <defs className="defs">
        <clipPath className="clip-path" id="clip0_2633_291">
          <rect
            className="rect"
            fill="white"
            height="24"
            transform="translate(10.667 12.0688)"
            width="24"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
